import carlos_path from 'url:/models/about/carlos.glb';
import pablo_path from 'url:/models/about/pablo.glb';
import rosma_path from 'url:/models/about/rosma.glb';

function setUpViewer(id, path, exposure){
    let viewer = document.getElementById(id);
    if (!viewer) return;

    viewer.exposure = exposure;
    viewer.src = path;
}

setUpViewer('carlos', carlos_path, 0.5);
setUpViewer('pablo', pablo_path, 0.5);
setUpViewer('rosma', rosma_path, 0.5);

new Glide('#carousel',
    {
        type: 'carousel',
        perView: 5,
        autoplay: 1000,
        breakpoints: {
            600: {
                perView: 2
            },
            800: {
                perView: 4
            },
            1000: {
                perView: 5
            }
        }
    }
).mount();

new Glide('#carousel2',
    {
        type: 'carousel',
        perView: 5,
        autoplay: 1000,
        breakpoints: {
            600: {
                perView: 2
            },
            800: {
                perView: 4
            },
            1000: {
                perView: 5
            }
        }
    }
).mount();